export const ERROR = 'FORGOT_PASSWORD/ERROR'
export const SUCCESS = 'FORGOT_PASSWORD/SUCCESS'
export const PROCESSING = 'FORGOT_PASSWORD/PROCESSING'
